import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgArrowRightLong = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 51 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#979797"
    strokeLinecap="square"
    {...props}
  >
    <path d="M.5 7.5h49.092m-6.092-6 6.092 6m-6.092 6 6.092-6" />
  </svg>
);
const Memo = memo(SvgArrowRightLong);
export default Memo;
